import { useQueryClient } from "@tanstack/react-query";

import type {
  AddWorkerReviewPayload,
  AddWorkerReviewResponse,
} from "@/schemas/review";
import { notify } from "@/utils";
import { Logger } from "@/utils/logger";

import { addWorkerReview } from "../api/workerReviewApi";
import { QueryKeys } from "../queryKeys";
import { useCustomMutation } from "../queryUtils";

export function useAddWorkerReview(workerId: string | undefined) {
  const queryClient = useQueryClient();
  return useCustomMutation<
    AddWorkerReviewResponse,
    Record<string, unknown>,
    AddWorkerReviewPayload
  >(addWorkerReview, {
    onError: (error: Record<string, unknown>) => {
      Logger.error("Add worker review failed:", error);
      notify.error("Failed to submit review. Please try again.");
    },
    onSuccess: (data) => {
      // Invalidate reviews and public profile for the worker
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.WORKER_REVIEWS, workerId],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.PUBLIC_USER_PROFILE, workerId],
      });
      return data;
    },
  });
}
